import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Components
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import Mobilya from './pages/Mobilya';
import BeyazEsya from './pages/BeyazEsya';
import YatakBazaBaslik from './pages/YatakBazaBaslik';
import Kurumsal from './pages/Kurumsal';
import Iletisim from './pages/Iletisim.js';

// Marka Sayfaları
import WeltewMobilya from './pages/MarkaSayfalari/WeltewMobilya';
import BellonaMobilya from './pages/MarkaSayfalari/BellonaMobilya';
import BekoBeyazEsya from './pages/MarkaSayfalari/BekoBeyazEsya';
import YatasYatak from './pages/MarkaSayfalari/YatasYatak.js';
import BellonaYatak from './pages/MarkaSayfalari/BellonaYatak.js';
import WeltewYatak from './pages/MarkaSayfalari/WeltewYatak.js';

// Google Analytics function
const usePageTracking = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-MZGW8TTF4T', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
};

// Page tracking wrapper component
const PageTracker = ({ children }) => {
  usePageTracking();
  return children;
};

function App() {
  return (
    <Router>
      <div className="App">
        <PageTracker>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mobilya" element={<Mobilya />} />
            <Route path="/beyaz-esya" element={<BeyazEsya />} />
            <Route path="/yatak-baza-baslik" element={<YatakBazaBaslik />} />
            <Route path="/kurumsal" element={<Kurumsal />} />
            <Route path="/weltew-mobilya" element={<WeltewMobilya />} />
            <Route path="/bellona-mobilya" element={<BellonaMobilya />} />
            <Route path="/beko-beyaz-esya" element={<BekoBeyazEsya />} />
            <Route path="/yatas-yatak" element={<YatasYatak />} />
            <Route path="/bellona-yatak" element={<BellonaYatak />} />
            <Route path="/weltew-yatak" element={<WeltewYatak />} />
            <Route path="/weltew-yatak" element={<WeltewYatak />} />
            <Route path="/iletisim" element={<Iletisim />} />
          </Routes>
        </PageTracker>
      </div>
    </Router>
  );
}

export default App;
